export const PROVIDER_PRAGMATIC = 8
export const PROVIDER_GAMES_GLOBAL = 7
export const PROVIDER_PARIPLAY = 6
export const PROVIDER_EVOLUTION = 5
export const PROVIDER_MAGNET = 4

// PROVIDER EVENT CODES
export const PARIPLAY_ERROR_INSUFFICIENT_FUNDS = 1
export const PARIPLAY_ERROR_AUTHENTICATION_FAILED = 4
export const PARIPLAY_ERROR_TOKEN_EXPIRED = 5
export const PARIPLAY_ERROR_INVALID_GAME = 7
export const PARIPLAY_ERROR_INVALID_TOKEN = 8
export const PARIPLAY_ERROR_BET_AMOUNT_UNDER_MINIMUM = 21
export const PARIPLAY_ERROR_INVALID_PLATFORM = 29
export const PARIPLAY_ERROR_GENERAL_ERROR = 900
export const PARIPLAY_OPEN_CASHIER = 'openCashier'
export const PARIPLAY_BALANCE_TOO_LOW = 'balanceTooLow'
export const PARIPLAY_GAME_LOADING_ENDED = 'gameLoadingEnded'
export const PARIPLAY_GAME_QUIT = 'gameQuit'
export const PARIPLAY_NOTIFY_CLOSE_CONTAINER = 'notifyCloseContainer'

export const PARIPLAY_COMMAND_UPDATE_BALANCE = 'updateBalance'
export const PARIPLAY_COMMAND_MUTE = 'mute'
export const PARIPLAY_COMMAND_UNMUTE = 'unmute'
export const PARIPLAY_COMMAND_SOUND_DISABLE = 'soundDisable'
export const PARIPLAY_COMMAND_SOUND_ENABLE = 'soundEnable'
export const PARIPLAY_COMMAND_STOP_AUTOPLAY = 'stopAutoplay'

export const PRAGMATIC_UPDATE_BALANCE = 'updateBalance'
export const PRAGMATIC_BALANCE_TOO_LOW = 'balanceTooLow'
export const PRAGMATIC_OPEN_CASHIER = 'openCashier'
export const PRAGMATIC_GAME_LOADING_ENDED = 'gameLoadingEnded'
export const PRAGMATIC_GAME_READY = 'gameReady'

export const EVOLUTION_APPLICATION_READY = 'EVO:APPLICATION_READY'
export const EVOLUTION_GAME_LOADED = 'GAME_LOADED'
export const EVOLUTION_GAME_READY = 'ready'
export const EVOLUTION_TYPE_GAME = 'game'
export const EVOLUTION_TYPE_LOBBY = 'lobby'
